export const hudMessages: Record<string, string> = {
	hint_howToWait: "Pressione [X] para esperar um turno",
	hint_destroyPortals: "Destrua portais para parar o spawn de inimigos",
	hint_autoShoot: "Pressione [TAB] para atirar automaticamente em um inimigo próximo",
	hud_powerPlantActivated: "Usina agora online",
	hud_powerPlantGate_noPower: "Não é possível abrir as portas. Sem energia.",
	hud_powerPlantGate_noKeyCard: "Cartão de acesso necessário.",
	hud_powerPlantGate_opening: "Abrindo portões...",
	hud_vendingMachine_noPower: "Sem energia",
	hud_terminal_noPower: "Sem energia",
	hud_terminal_noKeyCard: "Cartão de acesso necessário.",
	hud_reachedArea: "$1",
	hud_characterUnlocked: "Novo personagem desbloqueado: $1",
	hud_firstWeaponPickup: "Você pegou $1 — selecione com [$2]",
	hud_lowHpMedikit: "Vida baixa — pressione [H] para usar um medikit",
	prompt_activatePowerPlant: "ENTER - Ativar usina",
	prompt_openPowerPlantGate: "ENTER - Abrir portões",
	prompt_readSign: "ENTER - Ler placa",
	prompt_useVendingMachine: "ENTER - Usar máquina de venda",
	prompt_useTerminal: "ENTER - Usar terminal",
};
